// extracted by mini-css-extract-plugin
export default {"ag-styles":"f_g","policyPage":"f_t","introduction":"f_v","policyList":"f_w","settingsButton":"f_x"};